import store from '@store/index';
import { setBranchOffices, setDistributionCenters, setSalesChannels } from '@store/krispisStore';
import BranchOfficeServ from '@api/BranchOffices/BranchOfficeServ';
import DistributionCenterServ from '@api/DistributionCenters/DistributionCenterServ';
import SalesChannelServ from '@api/SalesChannels/SalesChannelServ';
import { UserType } from '@api/Users/User';

/**
 * Centralized loaders for the shared "krispis" catalogs (branch offices,
 * distribution centers, sales channels). These are the single source of truth
 * for that reference data: call them on login and after any create/edit/delete
 * so every screen that reads the slice stays consistent and fresh.
 */

export const refreshBranchOffices = async (user?: UserType): Promise<void> => {
    const currentUser = user ?? store.getState().auth.loggedUser;
    let branchOffices = await BranchOfficeServ.getBranchOffices();
    // Managers (and any non-admin) only see the branch offices assigned to them.
    if (currentUser && !currentUser.profile.branchOffices.includes('all')) {
        branchOffices = branchOffices.filter((b) => currentUser.profile.branchOffices.includes(b.id || ''));
    }
    store.dispatch(setBranchOffices(branchOffices));
};

export const refreshDistributionCenters = async (): Promise<void> => {
    const distributionCenters = await DistributionCenterServ.getDistributionCenters();
    store.dispatch(setDistributionCenters(distributionCenters));
};

export const refreshSalesChannels = async (): Promise<void> => {
    const salesChannels = await SalesChannelServ.getSalesChannels();
    store.dispatch(setSalesChannels(salesChannels));
};
